<template>
  <main id="main" style="margin-top:-20px; padding-bottom:50px" data-aos="fade-up">
    <section id="services">
      <div class="container" style="padding-bottom:80px">
        <div class="section-header">
          <h2>Find us here!</h2>
        </div>
        <div class="row mb-5">
          <div class="col-md-8">
            <div>
              <iframe
                height="500"
                width="100%"
                id="gmap_canvas"
                src="https://maps.google.com/maps?q=lOMBARDY%20Business%20Park&t=&z=13&ie=UTF8&iwloc=&output=embed"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
              ></iframe>
            </div>
          </div>
          <div class="col-md-4">
            <h4>CONTACT DETAILS</h4>
            <p>
              <strong>Phone:</strong>+27 (0)12 941 8497<br />
              <strong>Email: </strong
              ><a href="mailto:info@univateproperties.co.za"> info@univateproperties.co.za </a>
            </p>
            <p>
              <strong>Address:</strong> 105 Lombardy Business Park,<br />
              Cnr. Graham and Cole Rd.<br />
              Shere, Pretoria, 0084
            </p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
/* eslint-disable */
import AOS from "aos";
import "aos/dist/aos.css";
export default {
  created() {
    AOS.init;
  }
};
</script>

<style lang="scss" scoped></style>
